import { getTheme, getThemeMode } from '@payprompt/api-sdk';

// Utility function to update CSS variables with theme values
export const applyThemeToCSS = () => {
  const theme = getTheme();
  const themeMode = getThemeMode();
  const root = document.documentElement;
  
  // Log to debug theme application
  console.log('Applying theme:', theme);
  
  // Set the data-theme attribute for CSS-based theme switching
  root.setAttribute('data-theme', themeMode);
  
  root.style.setProperty('--button-color', theme.buttonColor);
  root.style.setProperty('--secondary-button-color', theme.secondaryButtonColor);
  root.style.setProperty('--link-color', theme.linkColor);
  root.style.setProperty('--hover-color', theme.hoverColor);
  root.style.setProperty('--font-family', theme.fontFamily);
  root.style.setProperty('--background-save-area', theme.backgroundSaveArea);
  root.style.setProperty('--background-color', theme.backgroundColor);
  root.style.setProperty('--text-primary', theme.textColor);
  root.style.setProperty('--text-secondary', theme.textSecondary);
  root.style.setProperty('--text-light', theme.textLight);
  root.style.setProperty('--border-color', theme.borderColor);
  root.style.setProperty('--card-background', theme.cardBackground);
  root.style.setProperty('--error-background', theme.errorBackground);
  root.style.setProperty('--error-text', theme.errorText);
  root.style.setProperty('--success-background', theme.successBackground);
  root.style.setProperty('--success-text', theme.successText);
  
  // Set gradient colors
  if (theme.linearGradient.length >= 2) {
    root.style.setProperty('--gradient-start', theme.linearGradient[0]);
    root.style.setProperty('--gradient-end', theme.linearGradient[1]);
  }
};

// Utility function to get theme values
export const getThemeValues = () => {
  return getTheme();
};